import React, { useEffect, useState } from "react";
import Button from "../../Button/Button";
import "./Sidebar.css";
import { useNavigate } from "react-router-dom";

/**Firebase Imports**/
import { logIn, logOut, useDispatch } from "../../../features/userSlice";
import {
	auth,
	db,
	signOut,
	updateProfile,
	getDoc,
	doc,
	storage,
	uploadBytesResumable,
	ref,
	getDownloadURL,
	updateDoc,
} from "../../../firebaseConfig";
import { showError } from "../../../helpers/showError";
import { useSelector, selectUser } from "../../../features/userSlice";
/** **/

const Sidebar = ({ className }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { user } = useSelector(selectUser);

	const [image, setImage] = useState(null);
	const [imagePreview, setImagePreview] = useState(auth.currentUser.photoURL);
	const [name, setName] = useState(auth.currentUser.displayName);
	const [userName, setUserName] = useState("");
	const [allowEdit, setAllowEdit] = useState(false);
	const [isProcessing, setIsProcessing] = useState(false);

	/**
	 * Main Functions
	 */
	const handleUpdate = async () => {
		setIsProcessing(true);

		if (image === null) {
			updateData(imagePreview);
			setIsProcessing(false);
			return;
		}
		updateImage();
	};
	/** **/

	/**
	 * Utility Functions
	 */
	const updateImage = async () => {
		const imageRef = ref(storage, `profile-images/${auth.currentUser.uid}`);
		const uploadTask = uploadBytesResumable(imageRef, image);
		uploadTask.on(
			"state-changed",

			// upload progress
			(snapshot) => {
				const progress =
					(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
				console.log("Upload is " + progress + "% done");
			},

			// error in image upload
			(error) => {
				showError(error);
			},

			// successful image upload
			() => {
				getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
					const token = downloadURL
						.substring(downloadURL.indexOf("?"))
						.toString();
					console.log("Image Updated");
					setImagePreview(token);
					setImage(null);
					updateData(token);
					return;
				});
			}
		);
	};

	const updateData = async (token) => {
		console.log(token);
		const userRef = doc(db, "users", auth.currentUser.uid);
		updateDoc(userRef, {
			userName: userName,
		})
			.then(() => {
				//username updated
				updateProfile(auth.currentUser, {
					photoURL: token,
					displayName: name,
				}).then(() => {
					//displayName updated
					dispatch(
						logIn({
							uid: auth.currentUser.uid,
							email: auth.currentUser.email,
							name: auth.currentUser.displayName,
							role: user.role,
						})
					);
					setIsProcessing(false);
				});
			})
			.catch((error) => showError(error));
	};

	const handleImage = (e) => {
		if (e.target.files[0] === null) {
			setImage(null);
			return;
		}

		const reader = new FileReader();
		reader.onload = (e) => {
			// set images
			if (reader.readyState === 2) {
				setImagePreview(reader.result);
			}
		};
		reader.readAsDataURL(e.target.files[0]);
		setImage(e.target.files[0]);
	};

	/** **/

	/**
	 * Get User Name
	 */
	useEffect(() => {
		const docRef = doc(db, "users", auth.currentUser.uid);
		const getUserName = async () => {
			const docSnap = await getDoc(docRef);
			if (docSnap.exists()) {
				setUserName(docSnap.data().userName);
			}
		};

		getUserName();
		return () => {
			console.log("");
		};
	}, []);
	/** **/

	return (
		<div
			className={`Sidebar absolute top-0 right-0 min-h-screen overflow-y-auto transition-all z-50 bg-white py-4 px-8 flex-col items-center justify-start ${className}`}
		>
			<p className="mt-5">Profile</p>

			<div className="avatar relative mt-10">
				<div className="circle1 rounded-full h-28 w-28 flex items-center justify-center overflow-hidden">
					<img
						src={
							image === null
								? imagePreview
									? "https://firebasestorage.googleapis.com/v0/b/john-trucking.appspot.com/o/profile-images%2F" +
									  auth.currentUser.uid +
									  imagePreview
									: require("../../../images/avatar.png")
								: imagePreview
						}
						alt="avatar_img"
						className="h-full object-cover rounded-full"
					/>
				</div>
				{allowEdit && (
					<div className="addImage absolute right-2 -bottom-1">
						<div className="relative h-fit w-fit overflow-hidden rounded-full">
							<input
								type="file"
								accept="image/*"
								multiple={false}
								className="absolute top-0 left-0  h-full w-full opacity-0"
								onChange={(e) => handleImage(e)}
							/>
							<p className="plus text-white h-6 w-6 flex items-center justify-center rounded-full">
								+
							</p>
						</div>
					</div>
				)}
			</div>

			<input
				type="text"
				name="name"
				id="name"
				className={`name mt-6 w-full text-center text-2xl font-bold rounded ${
					allowEdit && "border-2"
				}`}
				value={user.role === "admin" ? "Admin" : name}
				onChange={(e) => setName(e.target.value)}
			/>

			<input
				type="text"
				name="userName"
				id="userName"
				className={`name mt-1 w-full text-center text-lg rounded ${
					allowEdit && "border-2"
				}`}
				value={allowEdit ? userName : `@${userName}`}
				onChange={(e) => setUserName(e.target.value)}
			/>

			<Button
				mode={"filled"}
				size={"lg-1"}
				title={isProcessing ? "ooo" : allowEdit ? "UPDATE" : "EDIT PROFILE"}
				disabled={isProcessing}
				className={"text-lg rounded-full mt-6"}
				onClick={() => {
					if (allowEdit) {
						handleUpdate();
					}
					setAllowEdit(!allowEdit);
				}}
			/>
			{allowEdit && (
				<Button
					mode={"outlined"}
					size={"lg-1"}
					title={"CANCEL"}
					disabled={isProcessing}
					className={"text-lg rounded-full mt-2"}
					onClick={() => {
						setAllowEdit(!allowEdit);
						setImage(null);
						setImagePreview(auth.currentUser.photoURL);
						setName(auth.currentUser.displayName);
						setUserName(userName);
					}}
				/>
			)}

			<div className="line w-full my-6" />

			<div
				className="Settings buttons h-9 w-full flex items-center justify-start mb-3"
				onClick={() =>
					navigate(user.role === "admin" ? "/admin/settings" : "/settings")
				}
			>
				<img
					src={require("../../../images/settingsIcon.png")}
					alt="avatar_img"
					className="h-full object-contain"
				/>
				<p className="text-lg ml-3">Settings</p>
			</div>

			<div
				className="UserManagement buttons h-9 w-full flex items-center justify-start"
				onClick={() => alert("Button Clicked !")}
			>
				<img
					src={require("../../../images/userManagementIcon.png")}
					alt="avatar_img"
					className="h-full object-contain"
				/>
				<p className="text-lg ml-3 whitespace-nowrap text-ellipsis overflow-hidden">
					User Management
				</p>
			</div>

			<div className="line w-full my-6" />

			<div
				className="Information buttons h-9 w-full flex items-center justify-start mb-3"
				onClick={() => alert("Button Clicked !")}
			>
				<img
					src={require("../../../images/infoIcon.png")}
					alt="avatar_img"
					className="h-full object-contain"
				/>
				<p className="text-lg ml-3">Information</p>
			</div>

			<div
				className="Logout buttons h-9 w-full flex items-center justify-start"
				onClick={() => {
					signOut(auth)
						.then(() => {
							navigate(user.role === "admin" ? "/admin/" : "/");
							dispatch(logOut());
						})
						.catch((error) => {
							showError(error);
						});
				}}
			>
				<img
					src={require("../../../images/logoutIcon.png")}
					alt="avatar_img"
					className="h-full object-contain"
				/>
				<p className="text-lg ml-3">Log out</p>
			</div>
		</div>
	);
};

export default Sidebar;
